// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9b2fb24b","453":"43e8ab24"}[chunkId] + ".chunk.js";
};